import { Operation } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';

// Commander serves these only on /admin-graphql (see its requireAdminRole.ts ADMIN_OPERATIONS).
const adminFields = new Set([
  'adminUsers',
  'adminHostedShows',
  'adminAssumeUser',
  'adminHostingLimitOffenders',
  'adminUserFiles',
  'allJobs',
  'jobLogs',
  'adminDeleteAllUserData',
  'adminAddSubscriptionToUser',
  'adminRecoverDeletedFile',
  'adminSuspendHosting',
  'adminUpdateContent',
  'adminUpdateUser',
  'adminSetHasAlreadyPaused',
  'adminRerunJob',
  'adminRevokeSessions',
]);

export default function isAdminOperation(operation: Pick<Operation, 'query'>) {
  return getMainDefinition(operation.query).selectionSet.selections.some(
    selection => selection.kind === 'Field' && adminFields.has(selection.name.value),
  );
}
